import PropTypes from 'prop-types';
import { Text } from '@etg/wings';
import { useProperty, useTranslation } from '@eti/providers';
import { price } from '@eti/utils';
import { Price, CartRow } from './CartComponents';

const kunaCurrencyPriceFormat = {
  currencySymbol: 'HRK',
  decimalSymbol: '.',
  currencyExponent: 2,
  groupingSeparator: ' ',
  pattern: '¤ #,##0.00;¤ -#,##0.00',
};
const kunaPriceFormatter = price.createPriceFormatter(kunaCurrencyPriceFormat);

const CroatianKunaDisplay = ({ dataTestId, totalPriceWithFees }) => {
  const { t } = useTranslation();
  const { p } = useProperty();

  const priceInKuna = kunaPriceFormatter.formatPrice(
    totalPriceWithFees * p('IbeClient.DualCroatianCurrency.ExchangeRate'),
  );
  return (
    <CartRow>
      <Text>{t('IbeClient.DualCroatianCurrency.Label')}</Text>
      <Price data-testid={`${dataTestId}-DualCroatianCurrency`}>{priceInKuna}</Price>
    </CartRow>
  );
};

CroatianKunaDisplay.propTypes = {
  dataTestId: PropTypes.string,
  totalPriceWithFees: PropTypes.number,
};

export default CroatianKunaDisplay;
